module.exports = __webpack_public_path__ + "img/product31-shipin.e3e936f3.svg";